import { createSharedComposable } from '@vueuse/core'
import { useQuasar } from 'quasar'
import { computed } from 'vue'

export const useBreakpoints = createSharedComposable(() => {
  const $q = useQuasar()
  const isDesktop = computed(() => $q.screen.gt.sm)
  const isMobile = computed(() => $q.screen.lt.md)

  return {
    isDesktop,
    isMobile,
  }
})
